export const URL = "https://www.omdbapi.com/";
// export const URL_FULL_DATA: string = "http://www.omdbapi.com/";

export const API_KEY = "&apikey=342c4fd5";
